export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const FETCH_MESSAGE_THREAD_HEADERS = 'FETCH_MESSAGE_THREAD_HEADERS';
export const FORWARD_MESSAGE = 'FORWARD_MESSAGE';
export const GET_MESSAGE = 'GET_MESSAGE';
export const GET_POSSIBLE_RECIPIENTS = 'GET_POSSIBLE_RECIPIENTS';
export const REPLY_MESSAGE = 'REPLY_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';



// WEBPACK FOOTER //
// ./src/actions/messages/types.js